<template>
  <PageWrapper
    :active-page="PAGE_COMMUNITY_COMMUNITY"
    :active-section="SECTION_COMMUNITY"
    :breadcrumbs="breadcrumbs"
    align="left"
    page-name="Message"
    sub-title=""
    :title="nameOfReceiver"
    width="fixed"
    action-button-text="Call"
    :action-button-href="`/community/user/${userId}/video`"
  >
    <Chatroom
      :entity-id="userId"
      context="direct_message"
      :has-chat-room-header="false"
    />
  </PageWrapper>
</template>

<script>
import PageWrapper from "@/components/PageWrapper.vue";
import { PAGE_COMMUNITY_COMMUNITY, SECTION_COMMUNITY } from "@/constants/nav-constants";
import Chatroom from "%/components/community/chatrooms/slack-style/Chatroom.vue";
import { useOrganizationStore } from "@/stores/organization-store";
import { mapState } from "pinia";
import { useGeneralStore } from "%/stores/general-store";

export default {
  name: "DirectMessagePage",
  components: {
    Chatroom,
    PageWrapper,
  },
  props: {
    orgId: {
      type: Number,
      required: true,
    },
    receiverData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      SECTION_COMMUNITY,
      PAGE_COMMUNITY_COMMUNITY,
      breadcrumbs: [
        { url: "/", label: "Home" },
        { url: "/community", label: "Community" },
        { url: `/community/org/${this.orgId}/profile`, label: useOrganizationStore().orgProfileData.name },
      ],
    };
  },
  computed: {
    ...mapState(useGeneralStore, ["userId"]),
    nameOfReceiver() {
      return `${this.receiverData.first_name} ${this.receiverData.last_name}`;
    },
  },
};
</script>

<style lang="scss" scoped>

</style>
